import React from 'react';
import { PRIVATE_MARKDOWN_TABLE_ROW } from './row';
import { ITableRow, TableColumnAlignment } from '../../parser/table';
import { useCollectionKeys } from '../../../../framework/hooks/collection-keys';

interface IPRIVATE_MARKDOWN_TABLE_SECTIONProps {
  sectionElement: 'thead' | 'tbody' | 'tfoot';
  rows: ITableRow[];
  columnAlignments: TableColumnAlignment[];
}

export const PRIVATE_MARKDOWN_TABLE_SECTION: React.FunctionComponent<IPRIVATE_MARKDOWN_TABLE_SECTIONProps> = (props) => {
  const { sectionElement, rows } = props;
  const rowKeys = useCollectionKeys(rows);

  return (
    <>
      {sectionElement === 'thead' &&
      <thead>
        {rows.map((row, index) => <PRIVATE_MARKDOWN_TABLE_ROW key={rowKeys[index]} row={row} isHeaderRow={true} columnAlignments={props.columnAlignments} />)}
      </thead>}
      {sectionElement === 'tbody' &&
      <tbody>
        {rows.map((row, index) => <PRIVATE_MARKDOWN_TABLE_ROW key={rowKeys[index]} row={row} isHeaderRow={false} columnAlignments={props.columnAlignments} />)}
      </tbody>}
      {sectionElement === 'tfoot' &&
      <tfoot>
        {rows.map((row, index) => <PRIVATE_MARKDOWN_TABLE_ROW key={rowKeys[index]} row={row} isHeaderRow={false} columnAlignments={props.columnAlignments} />)}
      </tfoot>}
    </>
  );
};
